import {all, fork} from 'redux-saga/effects';

import {generalSettingsSaga} from '@dms/teas';

export function* rootSaga() {
  yield all([fork(generalSettingsSaga)]);
}
